import styled from "styled-components";

import { Text } from "../../../components/Text";
import { AdminMessage as AdminMessageModel } from "../../../model/admin/AdminMessage";
import { useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { Rounded } from "../../../theme/Rounded";
import { standardDate } from "../../../utils/Date";
import { TextWithTruncated } from "../../../components/TextWithTruncated";
import { Spacing } from "../../../theme/Spacing";
import { Flex } from "../../../components/Flex";

const Container = styled(Flex)`
  padding: ${Spacing.s};
  border: 1px solid ${({ theme }) => theme.darkSub};
  background-color: ${({ theme }) => theme.sub}22;
  border-radius: ${Rounded.md};
  flex-direction: column;
  position: relative;
  gap: ${Spacing.xs};

  p:first-child {
    white-space: normal;
  }
`;

const UnReadDot = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  background-color: ${({ theme }) => theme.danger};
  border-radius: ${Rounded.circle};
  position: absolute;
  top: ${Spacing.s};
  inset-inline-end: ${Spacing.s};
`;

type AdminMessageProps = {
  message: AdminMessageModel;
};

export const AdminMessage: React.FC<AdminMessageProps> = ({ message }) => {
  const user = useAppSelector(userSliceSelectors.selectLoggedInUser)!;

  return (
    <Container>
      <TextWithTruncated length={80}>{message.message}</TextWithTruncated>
      <Text color="darkerSub">
        {standardDate<string>(message.createdAt, user, true)}
      </Text>
      {message.read === false ? <UnReadDot /> : null}
    </Container>
  );
};
